<template>
  <div class="modal-field">
    <button class="modal-field__close-btn" @click="closeModal">
      <BaseIcon name="cross" />
    </button>
    <h1 class="modal-field__title" v-html="title"></h1>
    <FormField
      class="modal-field__form modals-container__scroll-content"
      @input="collectForm"
      scope="customobjects"
      :forbiddenKeys="modalData.usedKeys"
      :showTypeSelect="false"
      :showKeyHint="false"
    ></FormField>
    <div class="modal-field__buttons">
      <BaseButton title="Cancel" @click.native="closeModal" :disabled="loading.save"/>
      <BaseButton title="Add" @click.native="handleSubmit" theme="primary" :loading="loading.save"/>
    </div>
  </div>
</template>

<script>
  import FormField from '@/components/forms/FormField'
  import { MDSModalNewCustomObjectModel } from '@/models/modal-datasets.model'

  export default {
    components: {
      FormField
    },
    data () {
      return {
        title: 'Add a <strong>custom object</strong>',
        form: null,
        loading: {
          save: false
        }
      }
    },
    props: {
      modalData: MDSModalNewCustomObjectModel
    },
    methods: {
      closeModal () {
        this.$store.commit('modals/CLOSE_LAST_MODAL')
      },
      async handleSubmit () {
        const isValid = await this.$validator.validateAll()
        if (!isValid) {
          console.warn('Invalid form')
          return
        }

        try {
          this.loading.save = true
          this.$store.commit('shopCustomobjectsgroupsManage/ADD_CUSTOM_OBJECT', { customObject: this.form })
          await this.$store.dispatch('shopCustomobjectsgroupsManage/SAVE_CUSTOM_OBJECT')
        } catch (e) {
          console.error(e)
        } finally {
          this.loading.save = false
        }

        this.closeModal()
      },
      collectForm (form) {
        this.form = form
      },
      handleKeyEvent (e) {
        if (e.keyCode === 13) {
          this.handleSubmit()
        }
      },
    },
    mounted () {
      document.addEventListener('keydown', this.handleKeyEvent)
    },
    beforeDestroy () {
      document.removeEventListener('keydown', this.handleKeyEvent)
    }
  }
</script>

<style lang="scss" src="./modal-field.scss"></style>



// WEBPACK FOOTER //
// src/components/modals/modals-content/ModalNewCustomObject.vue